import { render, staticRenderFns } from "./CompanyDetailDistrictList.vue?vue&type=template&id=2fc3aa26&"
import script from "./CompanyDetailDistrictList.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailDistrictList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports